import { Button } from '@see-ui/core';
import React, { useState } from 'react';
import EditPaymentMethodsSlider from './EditPaymentMethodsSlider';

interface PaymentMethodsCardProps {
  paymentMethods: any;
  onUpdatePaymentMethods: (methods: any) => void;
  onSelectPaymentMethod?: any;
}
const PaymentMethodsCard: React.FC<PaymentMethodsCardProps> = ({
  paymentMethods,
  onUpdatePaymentMethods,
  onSelectPaymentMethod
}) => {
  const [showSlider, setShowSlider] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<any>(null);
  const [billingAddress, setBillingAddress] = useState<any>(null);

  const defaultMethod = Array.isArray(paymentMethods)
    ? paymentMethods.find((pm) => pm.isDefaultPaymentMethod)
    : null;

  React.useEffect(() => {
    if (defaultMethod && !selectedPaymentMethod) {
      setSelectedPaymentMethod(defaultMethod);
    }
    const billingAddress = selectedPaymentMethod?.address
      ? `${selectedPaymentMethod.address.addressLine1}, ${selectedPaymentMethod.address.city}, ${selectedPaymentMethod.address.state} ${selectedPaymentMethod.address.zipCode?.slice(0, 5)}-${selectedPaymentMethod.address.zipCode?.slice(5)}`
      : '';
    setBillingAddress(billingAddress);
  }, [defaultMethod, selectedPaymentMethod]);

  return (
    <>
      <div>
        <div className="flex items-center justify-between mb-2">
          <h3 className="mb-3 font-light">Payment </h3>
          <Button
            rounded
            variant="secondary"
            size="sm"
            onClick={() => setShowSlider(true)}
          >
            Edit
          </Button>
        </div>

        <p>
          A payment method will only be needed, if you have a copay for your
          medicine or if you request a faster shipping option. If you are unable
          to pay the copay, call carelonRx pharmacy at 833-396-0309
        </p>

        {selectedPaymentMethod && selectedPaymentMethod.card && (
          <>
            <div className="mt-4 ">
              <div className="font-semibold">
                {selectedPaymentMethod.card.cardSubType}-
                {selectedPaymentMethod.card.cardNumber.slice(-4)}
              </div>
              <div>
                Expires {selectedPaymentMethod.card.expirationMonth}/
                {selectedPaymentMethod.card.expirationYear}
              </div>
            </div>
            {billingAddress && (
              <div className="mt-2">
                <div className="font-semibold">Billing Address:</div>
                <div>{billingAddress}</div>
              </div>
            )}
          </>
        )}
      </div>
      {showSlider && (
        <EditPaymentMethodsSlider
          paymentMethods={paymentMethods}
          onUpdatePaymentMethods={onUpdatePaymentMethods}
          onClose={() => setShowSlider(false)}
          onSelectCard={(card) => {
            setSelectedPaymentMethod(card);
            setShowSlider(false);
            if (onSelectPaymentMethod) onSelectPaymentMethod(card);
          }}
        />
      )}
    </>
  );
};

export default PaymentMethodsCard;
